import React from 'react'

const LoadingAnimation = ({ dotsStyle, loadingText }) => {
  return (
    <div className=" flex space-x-2 justify-center items-center">
      <span className="text-black ">{loadingText}</span>
      <div className={`h-3 w-3  bg-black rounded-full ${dotsStyle}  animate-bounce [animation-delay:-0.3s] `}></div>
      <div className={`h-3 w-3  bg-black rounded-full ${dotsStyle}  animate-bounce [animation-delay:-0.15s] `}></div>
      <div className={`h-3 w-3  bg-black rounded-full ${dotsStyle}  animate-bounce loadingText`}></div>
    </div>
  )
}

export default LoadingAnimation
